import { Pipe, PipeTransform } from '@angular/core';
import { StripHtmlHelper } from '../helpers/strip-html.helper';

@Pipe({
  name: 'htmlStrip'
})
export class HtmlStripePipe implements PipeTransform {

  constructor(private stripHtmlHelper: StripHtmlHelper){}

  transform(value: string): unknown {
    return this.stripHtmlHelper.stripHtml(value)
  }
}
